import React from 'react';
import { View } from 'react-native';
import useTranslation from '../../hooks/translation-hook';
import Label from '../common/Label';
import ModalContainer from '../common/ModalContainer';

const MissionReferralMessage = ({ titleKey, bodyKey, onClose }: { titleKey: string; bodyKey: string; onClose: () => void }) => {
  const t = useTranslation();

  // Preferences can finish loading after the referral request. Translate inside
  // the mounted dialog so its copy follows the hydrated language too.
  return (
    <ModalContainer title={t(titleKey)} onConfirm={onClose} onClose={onClose}>
      <View>
        <Label numberOfLines={0} style={{ fontSize: 16, lineHeight: 22, textAlign: 'center' }}>{t(bodyKey)}</Label>
      </View>
    </ModalContainer>
  );
};

export default MissionReferralMessage;
